import type { NavBarExtension } from '@pflegenavi/frontend/layout';
import { nhAppMainPages } from '@pflegenavi/frontend/routing';
import { SvgIconStyle } from '@pflegenavi/web-components';
import { useTranslation } from 'react-i18next';

import reportingIcon from '../assets/reporting.svg';

export const useReportingV3NavConfig: () => NavBarExtension = () => {
  const { t } = useTranslation();

  return {
    item: {
      icon: <SvgIconStyle src={reportingIcon} sx={{ width: 1, height: 1 }} />,
      title: t('reporting-v3.title'),
      path: nhAppMainPages.REPORTING_V3,
      children: [
        {
          title: t('reporting-v3.nav.overview'),
          path: nhAppMainPages.REPORTING_V3_OVERVIEW,
        },
      ],
    },
  };
};
